<template>
  <div
    class="modal fade"
    id="deleteFile"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog leaveModal" role="document">
      <div class="modal-content">
        <div class="leaveModal-header">
          <button
            type="button"
            id="deleteFilePopClose"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <img src="@/assets/lems-v1/images/close-black-icon.svg" alt="" />
          </button>
          <h1>
            {{ constants.DELETE_FILE_POP_TEXT }}
          </h1>
        </div>
        <div class="leaveModal-btm">
          <button
            id="deleteFileCancelBtn"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="v1-button-outline-black"
          >
            {{ constants.CANCEL_BUTTON }}
          </button>
          <button
            id="deleteFileYesBtn"
            data-bs-dismiss="modal"
            class="v1-button-outline"
          >
            {{ constants.YES_BUTTON }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";

export default defineComponent({
  name: "DeleteFilePopup",
  data() {
    return {
      constants,
    };
  },
});
</script>
